import { mockSolarPanelsProductWithCalculations } from '@feh/solar-panels-store';
import type { SolarGetAddressInfoResponseSchema } from '@integration/api-client/feh';

export const mockSolarPanelsResultOverviewViewModel = {
  product: mockSolarPanelsProductWithCalculations,
  address: {
    postalcode: '2000AB',
    housenumber: 1,
    housenumberaddition: '2a',
    city: 'goat',
    street: 'goatstreet',
  } as SolarGetAddressInfoResponseSchema['address'],
  building: {
    roofArea: {
      barelySuited: 1,
      suited: 2,
      wellSuited: 3,
      total: 4,
    },
    monuments: {
      monumentAreas: [],
      nationalMonuments: [],
    },
    buildingYear: 1234,
    map: 'https://api1.tetraeder.com/api/map_nl/5211AK/4/?project=ahn3_noord_brabant&layer=radiation&lat=6743147.29409&lon=589077.994035&zoom=18',
  } as SolarGetAddressInfoResponseSchema['building'],
  showLoader: false,
};
